module.exports = {

  request (req, token) {
    this.options.http._setHeaders.call(this, req, {Authorization: 'JWT ' + token})
  },

  response (res) {
    if (res.status === 200 || res.status === 201) {
      return (res.data || {}).token
    }
  }
}



// WEBPACK FOOTER //
// ./src/auth/jwt.js